import * as Sentry from "@sentry/browser"

const reported = new WeakSet<object>()

/**
 * Another teacher's documents failing to load mustn't take this teacher's lesson down with them,
 * so the followed class's views hide what they can't show and report each failure once.
 */
export function reportFollowedLoadError(error: unknown): void {
  if (typeof error !== "object" || error === null || reported.has(error)) return
  reported.add(error)
  Sentry.captureException(error)
}
